export default __webpack_public_path__ + "static/media/arrow-up.375db867.svg";